// src/themes/index.ts
import { createTheme, ThemeOptions as MuiThemeOptions } from '@mui/material/styles'

import { components } from './components'
import { mixins } from './mixins'
import { palette } from './palette'
import { shadows } from './shadows'
import { CustomPaletteOptions } from './types'
import { typography } from './typography'

export const theme = (mode: 'dark' | 'light') => {
  const paletteConfig: CustomPaletteOptions = palette(mode)
  const componentsConfig = components(createTheme({ palette: paletteConfig }).palette)

  const themeOptions: MuiThemeOptions = {
    components: componentsConfig,
    mixins: mixins(),
    palette: paletteConfig,
    shadows: shadows(mode),
    typography: typography(),
  }

  return createTheme(themeOptions)
}

export { createTheme }
